import Dispatcher from "../dispatcher";

const BookHelpers = {
  bindToJigsawEvents(book) {
    // Most have arugments of (e, data)
    // book:selectionWithPosition and book:navigationRequested just have (data)
    // user:signout has no arguments
    const jigsawEvents = Dispatcher.getJigsawEvents();
    for (let i = 0; i < jigsawEvents.length; i++) {
      book.viewer.bind(
        jigsawEvents[i],
        function() {
          Dispatcher.emit.apply(
            Dispatcher,
            [jigsawEvents[i], book.isbn].concat([...arguments])
          );
        }.bind(this)
      );
    }
  },

  unbindJigsawEvents(book) {
    book.viewer.unbind(Dispatcher.getJigsawEvents());
  }
};

export default BookHelpers;
